import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'm15.5 15.5 5 5', key: '1ky94l' }],
  [
    'path',
    {
      d: 'm20.063 11.525 1.777-1.731a.53.53 0 0 0-.294-.905l-5.166-.755a2.1 2.1 0 0 1-1.595-1.16l-2.31-4.68a.53.53 0 0 0-.95.001L9.216 6.974a2.1 2.1 0 0 1-1.597 1.16l-5.165.755a.53.53 0 0 0-.294.906l3.736 3.637a2.1 2.1 0 0 1 .611 1.879l-.88 5.139a.53.53 0 0 0 .769.56l4.617-2.428a2.1 2.1 0 0 1 .987-.243 2 2 0 0 1 .132.004',
      key: '6uuto3',
    },
  ],
  ['path', { d: 'm20.5 15.5-5 5', key: '1w5am3' }],
];

/**
 * @component @name StarX
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTUuNSAxNS41IDUgNSIgLz4KICA8cGF0aCBkPSJtMjAuMDYzIDExLjUyNSAxLjc3Ny0xLjczMWEuNTMuNTMgMCAwIDAtLjI5NC0uOTA1bC01LjE2Ni0uNzU1YTIuMSAyLjEgMCAwIDEtMS41OTUtMS4xNmwtMi4zMS00LjY4YS41My41MyAwIDAgMC0uOTUuMDAxTDkuMjE2IDYuOTc0YTIuMSAyLjEgMCAwIDEtMS41OTcgMS4xNmwtNS4xNjUuNzU1YS41My41MyAwIDAgMC0uMjk0LjkwNmwzLjczNiAzLjYzN2EyLjEgMi4xIDAgMCAxIC42MTEgMS44NzlsLS44OCA1LjEzOWEuNTMuNTMgMCAwIDAgLjc2OS41Nmw0LjYxNy0yLjQyOGEyLjEgMi4xIDAgMCAxIC45ODctLjI0MyAyIDIgMCAwIDEgLjEzMi4wMDQiIC8+CiAgPHBhdGggZD0ibTIwLjUgMTUuNS01IDUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/star-x
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const StarX = createLucideIcon('star-x', __iconNode);

export default StarX;
